// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export var PushNotificationPermissionStatus;
(function (PushNotificationPermissionStatus) {
    PushNotificationPermissionStatus["DENIED"] = "DENIED";
    PushNotificationPermissionStatus["GRANTED"] = "GRANTED";
    PushNotificationPermissionStatus["SHOULD_REQUEST"] = "SHOULD_REQUEST";
    PushNotificationPermissionStatus["SHOULD_EXPLAIN_THEN_REQUEST"] = "SHOULD_EXPLAIN_THEN_REQUEST";
})(PushNotificationPermissionStatus || (PushNotificationPermissionStatus = {}));
//# sourceMappingURL=types.js.map